import React, { Component } from "react";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import Container from "../../../modules/commons/Container";
import FlexView from "react-flexview";
import SimpleInput from "../../../modules/SimpleInput";
import * as R from "ramda";
import { defaultFilter, tableConfig, formGroup } from "./config";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../modules/custom/customTable";
import { flattenFormGroupObject, removeNullFields } from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import MasterServiceModifying from "./components/masterServiceModifying";
import MasterServiceFilter from "./components/masterServiceFilter";
import MasterServiceUpload from "./components/masterServiceUpload";
import { ACTIVITY_TYPE, HttpStatus, Status } from "../../common/Constants";
import ToggleButton from "react-toggle-button";
import { service } from "./service";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import { contructQueryParam, fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";

class MasterService extends Component {
  getTableConfig = () => [
    ...tableConfig(this.state.pagination),
    {
      name: "serviceId",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          const status = this.state.dataTable?.[rowIndex]?.status;
          const { menuAccess } = this.props;
          const disableUpdate = !menuAccess?.updateAccess;
          return (
            <FlexView
              vAlignContent="center"
              style={{ justifyContent: "space-evenly", gap: "5px" }}
            >
              <ToggleButton
                thumbStyle={{
                  opacity: disableUpdate ? 0.5 : 1,
                  cursor: disableUpdate ? "not-allowed" : "pointer",
                }}
                trackStyle={{
                  opacity: disableUpdate ? 0.5 : 1,
                  cursor: disableUpdate ? "not-allowed" : "pointer",
                }}
                value={R.equals(status, Status.ACTIVE)}
                onToggle={(value) => {
                  if (disableUpdate) return;
                  this.handleToggleValue(
                    val,
                    !value ? Status.ACTIVE : Status.INACTIVE
                  );
                }}
              />
              <SimpleButton
                category="action_button"
                disabled={disableUpdate}
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: disableUpdate ? "gray" : "red" }}
                    className="fa fa-lw fa-pencil-alt"
                  />
                }
                onClick={() =>
                  this.handleModifyingVisibility(val, ACTIVITY_TYPE.UPDATE)
                }
              />
              <SimpleButton
                category="action_button"
                disabled={!menuAccess?.deleteAccess}
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: !menuAccess?.deleteAccess ? "gray" : "red" }}
                    className="fa fa-lw fa-trash"
                  />
                }
                onClick={() => this.handleDeleteVisibility(val)}
              />
            </FlexView>
          );
        },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      activityType: null,
      dataTable: [],
      loading: false,
      modifyingVisible: false,
      filterVisible: false,
      uploadVisible: false,
      filterData: defaultFilter,
      submittedFilterData: {},
      namaJasa: null,
      isFilter: false,
      isFetch: false,
      pagination: {
        totalData: 0,
        page: 1,
        limit: 5,
      },
      confirmation: {
        visible: false,
        content: null,
      },
      deleteId: "",
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchData();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    if (
      (prevState.pagination.page !== this.state.pagination.page ||
        prevState.pagination.limit !== this.state.pagination.limit) &&
      !this.state.isFetch
    ) {
      this.handleTriggerLoading();
      await this.fetchData(
        service.constructFilter(this.state.submittedFilterData),
        this.state.pagination.page,
        this.state.pagination.limit
      );
      this.handleTriggerLoading();
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async (
    filter = {},
    page = this.state.pagination.page,
    limit = this.state.pagination.limit
  ) => {
    this.setState((prevValue) => ({ ...prevValue, isFetch: true }));
    let { submittedFilterData } = this.state;
    let reqBody = removeNullFields(
      R.isEmpty(filter) ? service.constructFilter(submittedFilterData) : filter
    );
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceMainPage,
      menuName: "Master Jasa/Job",
      setError: this.props.setError,
      args: {
        ...reqBody,
        limit,
        page,
      },
    });
    if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
      await this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
          page: page,
          limit: limit
        },
      }));
    }
    this.setState((prevValue) => ({ ...prevValue, isFetch: false }));
  };

  handleSubmitFilter = async (filter) => {
    this.handleTriggerLoading();
    await this.setState((prevValue) => ({
      ...prevValue,
      isFilter: !R.isEmpty(filter),
      namaJasa: null,
      submittedFilterData: filter,
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
      },
    }));
    await this.fetchData(service.constructFilter(filter), 1);
    this.handleTriggerLoading();
  };

  handleSearch = async () => {
    this.handleTriggerLoading();
    await this.setState((prevValue) => ({
      ...prevValue,
      isFilter: false,
      submittedFilterData: { namaJasa: this.state.namaJasa },
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
      },
    }));
    await this.fetchData({ namaJasa: this.state.namaJasa }, 1);
    this.handleTriggerLoading();
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    const newLimit = tableState.rowsPerPage;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: newLimit,
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleModifyingVisibility = (id, activityType) => {
    if (R.equals(activityType, ACTIVITY_TYPE.UPDATE)) {
      this.setState((prevValue) => ({
        ...prevValue,
        modifyingVisible: !prevValue.modifyingVisible,
        selectedData: prevValue.dataTable.find((item) =>
          R.equals(item.serviceId, id)
        ),
        activityType: activityType,
      }));
      return;
    }
    this.setState((prevValue) => ({
      ...prevValue,
      modifyingVisible: !prevValue.modifyingVisible,
      selectedData: null,
      activityType: activityType,
    }));
  };

  handleUploadVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      uploadVisible: !prevValue.uploadVisible,
    }));
  };

  handleSuccessUpload = async () => {
    this.handleConfirmationVisibility(true, "Data Behasil Disimpan");
    this.handleUploadVisibility();
    this.fetchData({}, 1);
  };

  handleToggleValue = async (serviceId, status) => {
    this.handleTriggerLoading();
    const req = {
      serviceId,
      status,
    };
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceUpdateStatus,
      menuName: "Master Jasa/Job",
      setError: this.props.setError,
      args: req,
    });
    if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
      await this.fetchData(
        service.constructFilter(this.state.submittedFilterData),
        this.state.pagination.page,
        this.state.pagination.limit
      );
    }
    // todo hit api update status and re fetch data tab
    this.handleTriggerLoading();
  };

  handleSubmit = async (controls) => {
    this.handleTriggerLoading();
    let formGroup = flattenFormGroupObject(controls);
    let req = removeNullFields({
      ...formGroup,
      frt: Number(formGroup.frt),
      serviceCategory: formGroup.serviceCategory?.value,
      kodeVarian: formGroup.kodeVarian?.label,
      namaVarian: formGroup.namaVarian?.label,
    });
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceSubmit,
      menuName: "Master Jasa/Job",
      setError: this.props.setError,
      args: req,
    });
    if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
      await this.fetchData(
        service.constructFilter(this.state.submittedFilterData),
        this.state.pagination.page,
        this.state.pagination.limit
      );
      this.handleModifyingVisibility();
      this.handleConfirmationVisibility(true, "Data Berhasil Disimpan.");
    }
    this.handleTriggerLoading();
  };

  handleConfirmationVisibility = (visible, content) => {
    this.setState((prevValue) => ({
      ...prevValue,
      confirmation: {
        visible,
        content,
      },
    }));
  };

  handleDeleteVisibility = (id) => {
    this.setState((prevValue) => ({ ...prevValue, deleteId: id }));
  };

  handleDelete = async () => {
    this.handleTriggerLoading();
    await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceDelete,
      menuName: "Master Jasa/Job",
      setError: this.props.setError,
      args: contructQueryParam({ serviceId: this.state.deleteId }),
    });
    this.handleConfirmationVisibility(true, "Data Behasil Dihapus");
    this.handleDeleteVisibility("");
    await this.fetchData(
      service.constructFilter(this.state.submittedFilterData),
      this.state.pagination.page,
      this.state.pagination.limit
    );
    this.handleTriggerLoading();
  };

  render() {
    return (
      <>
        <Container>
          <FlexView
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <FlexView vAlignContent="center" style={{ gap: "20px" }}>
              <SimpleInput
                id="input_text_service_name"
                placeholder="Nama Jasa/Job"
                name="namaJasa"
                containerclassname="margin-bottom-5px width width-250px"
                value={this.state.namaJasa}
                onChange={({ target }) =>
                  this.handleChangeSearchValue(target.name, target.value)
                }
              />
              <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
            </FlexView>
            <SimpleButton
              className="btn background-red"
              category="action_button"
              onClick={this.handleFilterVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>
          <SimpleDataTable
            key={`${this.state.pagination.page}-${this.state.pagination.limit}-${this.state.dataTable.length}`}
            data={this.state.dataTable}
            columns={this.getTableConfig()}
            toCount={this.state.pagination.totalData}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleRowsPerPage
            )}
            footerAdditionalButtons={
              <>
                <SimpleButton
                  disabled={!this.props.menuAccess?.createAccess}
                  secondary={!this.props.menuAccess?.createAccess}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  onClick={() =>
                    this.handleModifyingVisibility(null, ACTIVITY_TYPE.CREATE)
                  }
                >
                  Tambah
                </SimpleButton>
                <SimpleButton onClick={this.handleUploadVisibility}>
                  Upload
                </SimpleButton>
              </>
            }
          />
        </Container>
        {this.state.modifyingVisible && (
          <MasterServiceModifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            activityType={this.state.activityType}
            visible={this.state.modifyingVisible}
            onClickClose={this.handleModifyingVisibility}
            onSubmit={this.handleSubmit}
            triggerLoading={this.handleTriggerLoading}
          />
        )}
        {this.state.filterVisible && (
          <MasterServiceFilter
            {...this.props}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            triggerLoading={this.handleTriggerLoading}
            isFilter={this.state.isFilter}
            submittedFilterData={this.state.submittedFilterData}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {this.state.uploadVisible && (
          <MasterServiceUpload
            {...this.props}
            visible={this.state.uploadVisible}
            onClickClose={this.handleUploadVisibility}
            triggerLoading={this.handleTriggerLoading}
            onSuccessUpload={this.handleSuccessUpload}
          />
        )}
        {this.state.confirmation.visible && (
          <SimpleAlert
            title="Information"
            content={
              <div>
                <p>{this.state.confirmation.content}</p>
              </div>
            }
            visible={this.state.confirmation.visible}
            onClickClose={() => this.handleConfirmationVisibility(false, null)}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ alignItems: "center" }}>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleConfirmationVisibility(false, null)}
                />
              </FlexView>
            }
          />
        )}
        {!R.equals(this.state.deleteId, "") && (
          <SimpleAlert
            title="Information"
            content="Apakah anda yakin ingin menghapus data ini?"
            visible={!R.equals(this.state.deleteId, "")}
            onClickClose={() => this.handleDeleteVisibility("")}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ alignItems: "end" }}>
                <SimpleButton
                  type="button"
                  text="Tidak"
                  onClick={() => this.handleDeleteVisibility("")}
                />
                <SimpleButton
                  type="button"
                  text="Ya"
                  onClick={this.handleDelete}
                />
              </FlexView>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterService);
